<script>
import apolloMixin from "@/mixins/apollo.mixin";
import tableColumnsMixin from "@/mixins/tableColumns.mixin";
import TableColumnsSettings from "@/components/TableColumnsSettings.vue";
import FocusGroupList from "@/views/settings/focus-group/index/_components/FocusGroupList.vue";
import { buildFocusGroupListTableHeaders } from "@/views/settings/focus-group/index/config/focusGroupListTableHeaders";
import { focusGroupQuery } from "@/views/settings/focus-group/index/gql/queries";
import { mapGetters } from "vuex";

export default {
  name: "FocusGroup",

  components: { FocusGroupList, TableColumnsSettings },

  mixins: [apolloMixin, tableColumnsMixin],

  data() {
    return {
      featuresList: [],
      tableColumnsId: "focus-group-list",
    };
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),

    tableHeaders() {
      return buildFocusGroupListTableHeaders({
        t: (key) => this.$t(key),
      });
    },

    focusGroupListHeaders() {
      if (!this.isTableColumnsReady) {
        return null;
      }

      return this.visibleTableHeaders;
    },
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const { features } = await this.$get(focusGroupQuery);

      this.featuresList = features.map((feature) => {
        const { id, name, code, isActive, customers } = feature;

        return {
          id,
          name,
          code,
          customers: customers.length ? customers.map((customer) => customer.name).join(", ") : "-",
          isActive: isActive
            ? this.$t("focusGroup.isActive.activated")
            : this.$t("focusGroup.isActive.deactivated"),
          page: "FocusGroupEdit",
        };
      });
    },

    onClickRow(id) {
      this.$router.push({ name: "FocusGroupEdit", params: { id } });
    },
  },
};
</script>

<template>
  <OurPage data-cy="users-page" :title="$t('title.focusGroup._')" gray>
    <FocusGroupList :items="featuresList" :headers="focusGroupListHeaders" @onClickRow="onClickRow" />

    <template #header-right>
      <TableColumnsSettings
        v-if="!isMobileDevice && isTableColumnsReady"
        :headers="tableHeaders"
        :table-key="tablePreferenceKey"
        data-cy="focus-group-list-columns"
      />
    </template>
  </OurPage>
</template>
